// extracted by mini-css-extract-plugin
export var integrationButton = "_ax-0";